import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRightIcon } from "@radix-ui/react-icons";

interface ProductTypeCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onSelect: () => void;
  disabled?: boolean;
}

export const ProductTypeCard: React.FC<ProductTypeCardProps> = ({
  title,
  description,
  icon,
  onSelect,
  disabled = false,
}) => {
  return (
    <div
      className={`border rounded-lg p-6 flex flex-col h-full ${
        disabled
          ? "opacity-60 cursor-not-allowed bg-gray-50"
          : "hover:border-primary cursor-pointer"
      }`}
      onClick={disabled ? undefined : onSelect}
    >
      <div className="flex justify-center mb-6">{icon}</div>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground text-sm flex-grow mb-4">
        {description}
      </p>
      <Button
        variant="ghost"
        className="justify-start px-0 text-primary font-medium"
        size="sm"
        onClick={disabled ? undefined : onSelect}
        disabled={disabled}
      >
        Select <ArrowRightIcon className="ml-1 h-4 w-4" />
      </Button>
    </div>
  );
};
